import {html, svg} from '../lib/lit-html.js';
import {classMap} from '../lib/lit/directives/class-map.js';
import {priceFilter} from './pricefilter.js';

function isChecked(state, name, value){
	return state.search.attributes.hasOwnProperty(name) 
		&& state.search.attributes[name].includes(value);
}

function getFacet(state, name, value){
	return state.facets[name]?.find(b => b.name == value)?.count || 0;
}

function minus(){
	return svg`
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10">
			<rect x="0" y="4" width="10" height="2" />
			<rect x="4" y="4" width="2" height="2" class="vert-spar" />
		</svg>
	`;
}

function getVisableName(state, key){
	if (state.attributeNames[key]){
		return state.attributeNames[key];
	}
	return key.toLowerCase();
}

export function attributeFilter(state){
	return html`
		<div class="ekm-search-page-attributes">
			<div class="ekm-search-page-attributes-title">
				<div class="ekm-search-page-attributes-title-text">Filters</div>
				<div class="ekm-search-page-attributes-clear-all">Clear All</div>
			</div>
			${(state.showPriceFilter) ? priceFilter(state) : []}
			${Object.keys(state.filteredAttributes).map((k, i) => {
				var classes = {
					'ekm-search-page-attribute': true,
					'ekm-search-page-attributes-collapsed': state.collapsedAttributes.includes(k),
				};
				return html`
					<div class=${classMap(classes)}>
						<div class="ekm-search-page-attribute-name">
							<div>${getVisableName(state, k)}</div>
							<div class="ekm-search-page-attribute-toggle" data-key="${k}">
								${minus()}
							</div>
						</div>
						<div class="ekm-search-page-attribute-values">
							<div>
								${state.filteredAttributes[k].map((v, j) => {
									var facets = getFacet(state, k, v);
									var classes = {
										'ekm-search-page-attribute-value': true,
										'ekm-search-page-attribute-value-zero-facets': facets == 0
									};
									return html`
									<div class=${classMap(classes)}>
										<input 
										type="checkbox" 
										id="${`EkmSearchAttr-${i}-${j}`}"
										name="${`ekm-search-attr[${k}]`}" 
										value="${v}" 
										.checked=${isChecked(state, k, v)} />
										<label for="${`EkmSearchAttr-${i}-${j}`}">
										${v} <span class="ekm-search-page-facet">(${facets})</span>
										</label>
									</div>
									`
								})}
							</div>
						</div>
					</div>
				`
			})}
		</div>
	`;
}

export function attributeFilterSkeleton(state){
	return html`
		<div class="ekm-search-page-attributes skeleton">
		</div>
	`;
}